/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */

import { Column } from '@g17eco/molecules/tracking-list';
import { ColumnCommonProps } from '@g17eco/types/survey-question-list';

type ColumnBookmarkProps = Pick<ColumnCommonProps, 'isBookmarked' | 'toggleBookmark'>;

export const ColumnBookmark = (props: ColumnBookmarkProps) => {
  const { isBookmarked, toggleBookmark } = props;
  const icon = isBookmarked ? 'solid' : 'light';

  return (
    <Column className='pr-0' onClick={toggleBookmark}>
      <i className={`fa-${icon} fa-bookmark`}></i>
    </Column>
  );
};
